import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle, Section, selectUser, useCloneEntity, UserState } from 'gossamer-front-end';
import { TaskDefinition } from 'gossamer-model';
import { CustomInfo } from 'cb-unified';
import { getListRowLink } from 'gossamer-unified';

export const WorkflowCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const LocalTaskDefinition = useCloneEntity(TaskDefinition, (local) => {
    Object.values(local.fields).forEach((field) => {
      field.visible = false;
    });
    local.fields.label.visible = true;
  });

  return (
    <>
      <PageTitle title="Create a new Workflow" subtitle="Use workflows to organise your tasks and processes" />
      <Section>
        {user.userId && (
          <FormManager
            compoundUrl="/main/~/workflow-create"
            handleCancel={() => navigate(`/admin/workflow/search`)}
            handleSuccess={({ keyOfFirstCreate }) =>
              navigate(getListRowLink(LocalTaskDefinition.listRowLink, keyOfFirstCreate))
            }
            initialization={{
              main: {
                type: 'create-single',
                entity: LocalTaskDefinition,
                override: {
                  institution_id: (user.customInfo as CustomInfo)?.adminInstitutionId,
                  type: 'ROOT',
                },
              },
            }}
          >
            <Create valuesKey="main" entity={LocalTaskDefinition} />
          </FormManager>
        )}
      </Section>
    </>
  );
};
